<template>

	<div class="inbox-body">

		<div class="inbox-header">
			<h1 v-translate>Enviadas</h1>
		</div>

		<div class="inbox-content">

			<filter-inbox :context="'sent'" />
			<list />

		</div>

	</div>

</template>

<style lang="scss" scoped>

	.inbox-body {
    	background: #fff;
    	border: 0;
	}

	.inbox-header h1 {
		font-family: 'Open Sans', Arial, Helvetica, sans-serif;
   		font-weight: 300;
	}

</style>

<script>

	import MessageSend from './';
	export default MessageSend;

</script>



// WEBPACK FOOTER //
// message-send.vue?4d093b83